import { FormFieldTypes } from "../../../../data/formFieldType";
import { GridColumnType } from "../../../../data/gridColumnType";


export const UploadCpdSearchFormData = {
  name: "stutusInfo",
  initialState: {
    searchText: null,
    eventName: null
  },
  formFields: [
    {
      id: "name",
      lable: "Name/GMP Number",
      Field_Name: "Name/GmaNumber",
      fieldType: FormFieldTypes.INPUT,
      dataField: "searchText",
      fieldSetting: {
        placeholder: "",
        allowSpace: true,
      },
      style: {
        containerCss: "col-lg-4 mt-2",
      },
    },
    {
      id: "eventName",
      lable: "Event Name",
      Field_Name: "Name/GmaNumber",
      fieldType: FormFieldTypes.INPUT,
      dataField: "eventName",
      fieldSetting: {
        placeholder: "",
        allowSpace: true,
      },
      style: {
        containerCss: "col-lg-4 mt-2",
      },
    },
  ],
  formSetting: {
    isViewOnly: false
  }
}

export const uploadCPDConfig = {
  columns: [
    {
      name: "Select",
      fieldName: "isApprove",
      colType: GridColumnType.CHECKBOX,
      colSettings: {
        allowEdit: false,
      },
      allowShort: false
    },
    {
      name: "upload Date",
      fieldName: "uploadDate",
      allowShort: false,
      colType: GridColumnType.DATE,
      colSettings: {
        format: 'DD MMM YYYY',
      }
    },
    {
      name: "Event Name",
      fieldName: "eventName",
      allowShort: false,
      colType: GridColumnType.Text,
    },
    {
      name: "Name",
      fieldName: "gmaName",
      allowShort: false,
      colType: GridColumnType.Text,
    },
    {
      name: "GMP Number",
      fieldName: "gmaNumber",
      allowShort: false,
      colType: GridColumnType.Text,
    },
    {
      name: "Status",
      fieldName: "status",
      colType: GridColumnType.Text,
    },
  ],
};
